package com.veldekar.components.logs

import androidx.compose.runtime.*
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.data.*
import com.varabyte.kobweb.core.layout.Layout
import com.varabyte.kobweb.core.layout.NoLayout
import com.varabyte.kobweb.core.init.InitRoute
import com.varabyte.kobweb.core.init.InitRouteContext
import com.varabyte.kobwebx.frontmatter.*
import com.varabyte.kobwebx.markdown.*
import com.veldekar.components.widgets.LocalizedSessionDate
import com.veldekar.components.widgets.InvertibleImage

@Composable
fun Log_2023_08_18_Day_1() {
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("We rejoin our heroes who had just survived an ambush of Goblinoids in the ruins outside an ancient cave exit.")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Having oriented himself while they were outdoors, Goram explains to the group that he is confident he could lead them overland the rest of the way to Malus. The dwarves are completely onboard with this plan after the horrors they have witnessed in the caverns, and the heroes are ready for a change of pace and perhaps an opportunity to hunt some fresh food.")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("The outside is breezy and cooler than the cave. They follow a weakly defined trail — perhaps a game or hunter’s trail.")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Our heroes setup camp for the night.  During the 3rd watch, clouds start to cover the night sky.")
    }
}
